export const CONNECT_MISSING = {
  SET_CONNECT_MISSING_BANK: 'SET_CONNECT_MISSING_BANK',
  SET_CONNECT_MISSING_VOUCHER: 'SET_CONNECT_MISSING_VOUCHER',
  GET_CONNECT_MISSING_VOUCHER_REQUEST: 'GET_CONNECT_MISSING_VOUCHER_REQUEST',
  GET_CONNECT_MISSING_VOUCHER_SUCCESS: 'GET_CONNECT_MISSING_VOUCHER_SUCCESS',
  GET_CONNECT_MISSING_VOUCHER_FAIL: 'GET_CONNECT_MISSING_VOUCHER_FAIL',
  REMOVE_RECORD_VOUCHER: 'REMOVE_RECORD_VOUCHER',
  SET_CONNECT_MISSING_FILTER_VOUCHER: 'SET_CONNECT_MISSING_FILTER_VOUCHER',
};
